import { createFeature, createReducer, on } from '@ngrx/store';

import { MobiUiLanguage, MobiUiMessage } from '@mobi/rwc-ui-components-ng-jslib';
import { Language } from '@mobi/rwc-utils-ng-jslib';

import { AppContext, AppSource, B2E, MOBILIAR } from '../../common.constant';
import { Links } from '../../core/setting';

import { oivAlertActions, oivCoreSharedActions, oivOverlayActions } from './oiv-core-shared.actions';

export interface CoreSharedState {
    source: AppSource;
    context: AppContext;
    language: MobiUiLanguage | Language;
    isMobileMode: boolean;
    isApprovalMode: boolean;
    alerts: MobiUiMessage[];
    isOverlayOpen: boolean;
    links: Links;
}

const initialState: CoreSharedState = {
    source: MOBILIAR,
    context: B2E,
    language: 'de',
    isMobileMode: false,
    isApprovalMode: false,
    alerts: [],
    isOverlayOpen: false,
    links: {
        dataProtection: '',
        instruction: '',
        imprint: '',
        legalInfo: '',
        contactAndFeedback: '',
        notFoundPageOverview: '',
        notFoundPageOverviewRedNet: '',
        notFoundPageContact: '',
        notFoundPageCustomerPortal: '',
        mobiliarLegalAdviser: '',
    },
};

export const oivCoreSharedFeature = createFeature({
    name: 'oivCoreShared',
    reducer: createReducer<CoreSharedState>(
        initialState,
        on(oivCoreSharedActions.source, (state, { source }) => {
            return {
                ...state,
                source,
            };
        }),
        on(oivCoreSharedActions.links, (state, { links }) => {
            return {
                ...state,
                links,
            };
        }),
        on(oivCoreSharedActions.context, (state, { context }) => {
            return {
                ...state,
                context,
            };
        }),
        on(oivCoreSharedActions.language, (state, { language }) => {
            return {
                ...state,
                language,
            };
        }),
        on(oivCoreSharedActions.mobileMode, (state, { isMobileMode }) => {
            return {
                ...state,
                isMobileMode,
            };
        }),
        on(oivCoreSharedActions.approvalMode, (state, { isApprovalMode }) => {
            return {
                ...state,
                isApprovalMode,
            };
        }),
        on(oivOverlayActions.open, state => ({ ...state, isOverlayOpen: true })),
        on(oivOverlayActions.close, state => ({ ...state, isOverlayOpen: false })),
        on(oivAlertActions.add, (state, alert) => ({
            ...state,
            alerts: [...state.alerts, alert],
        })),
        on(oivAlertActions.remove, (state, alert) => ({
            ...state,
            alerts: state.alerts.filter(m => m.id !== alert.id),
        })),
    ),
});
